import React, { useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import InputResponsiblePerson from '@components/framework/input/InputResponsiblePerson/InputResponsiblePerson.tsx';
import { LovDTO } from '@api/ringil-api.v2.tsx';

interface ComponentProps {
  secured?: SecuredConfig;
  required?: boolean;
  readonly?: boolean;
  disponentPerson: LovDTO;
  onChange: (responsiblePerson: LovDTO) => void;
}

const InternalInfoDisponentTag: React.FC<ComponentProps> = ({ secured, readonly, required, disponentPerson, onChange }) => {
  const [internalValue, setInternalValue] = useState(disponentPerson);
  const { tr } = useTranslationLgs();

  const renderText = (disponentPerson: LovDTO) => {
    return disponentPerson ? disponentPerson.name : null;
  };

  return (
    <>
      <ButtonTag secured={secured}
        label={tr("InternalInfoDisponentTag.disponent", "Disponent")}
        required={required}
        readonly={readonly}
        value={renderText(disponentPerson)}
        onSave={(onSuccess) => {
          onChange(internalValue);
          onSuccess();
        }}
        autoClose
        dataTestId="internalInfo-disponent"
      >
        <InputResponsiblePerson 
          responsiblePerson={internalValue} 
          onChange={setInternalValue}
          dataTestId="internalInfo-disponentList"
        />
      </ButtonTag>
    </>);

};

export default InternalInfoDisponentTag;